<template>
    <div class="frut-45-light">
        <LoginPanel itemref="loginPanel" v-show="currentPanel != 'start'" v-bind:userContent="userContent"></LoginPanel>
        <StartPanel v-show="currentPanel == 'start'" v-bind:searchData="searchContent"></StartPanel>
        <SearchPanel v-show="currentPanel == 'search'" v-bind:searchData="searchContent"></SearchPanel>
        <PartPlaceHolder v-show="currentPanel == 'loading'"></PartPlaceHolder>
        <PartPanel v-show="currentPanel == 'part'" v-bind:partContent="partContent" v-bind:previewContent="previewContent" v-bind:exportContent="exportContent" v-bind:userContent="userContent"></PartPanel>
        <hr />
        <footer class="text-center">
            <p>
                &copy; Copyright Ultra Librarian {{ new Date().getFullYear() }}
            </p>
        </footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';
    import $ from 'jquery';

    import SearchPanel from "./SearchPanel.vue";
    import StartPanel from "./StartPanel.vue";
    import PartPanel from "./PartPanel.vue";
    import PartPlaceHolder from "./PartPlaceHolder.vue";
    import LoginPanel from "./LoginPanel.vue";

    export default {
        name: "Home",
        data() {
            return {
                currentPanel: "start",
                userContent: {
                    loggedin: false,
                    username: ""
                },
                quitExport: false,
                previewContent: {
                    threed_content: {
                        has_3d: false,
                        part_unique_id: "",
                        url: ""
                    },
                    symbol_preview: {},
                    footprint_preview: {}
                },
                exportContent: {
                    exportGroups: [],
                    exportToken: ""
                },
                partContent: {
                    manufacturer: "",
                    partNumber: ""
                },
                searchContent: {
                    manufacturerList: [],
                    searchResult: {
                        items: [],
                        queryText: "",
                        mfrId: "",
                        paging: {
                            showPaging: true,
                            url: "",
                            pages: []
                        },
                        resultCount: 0
                    },
                    searchManufacturerId: "",
                    searchText: ""
                }
            }
        },
        computed: {
            appUrl: function() {
                return process.env.VUE_APP_API_URL;
            }
        },
        components: {
            SearchPanel,
            StartPanel,
            PartPanel,
            PartPlaceHolder,
            LoginPanel
        },
        mounted() {
            this.$root.processExport = false
            axios.defaults.withCredentials = true;
            axios.defaults.baseURL = this.appUrl;
            this.$root.$emit('login_refresh');

            this.$root.$on('select_part', (partUUID) => {
                //Set the active panel
                this.$root.$emit('change_panel', 'loading');
                axios
                    .get('api/v1/part/detail?puid=' + partUUID, { crossdomain: true })
                    .then(response => {
                        if (response.data) {
                            this.partContent = response.data.part_content;
                            this.previewContent = response.data.preview_data;
                            this.exportContent = response.data.export_request;

                            Vue.nextTick(() => {
                                $('.ul-html-tooltip').each(function (index, element) {
                                    if ($(element) && $(element).data('tip')) {
                                        $(element).tooltip({
                                            html: true,
                                            title: $('#' + $(element).data('tip')).html()
                                        });
                                    }
                                });
                            });

                            this.$root.$emit('change_panel', 'part');
                        }
                    })
                    .catch(() => {
                        this.$root.$emit('general_error', 'Part Failed');
                    });
            });

            this.$root.$on('search_parts', (mfrId, searchText, page = 0) => {
                var searchBase = 'api/v1/part/Search?';
                var queryString = '';
                if (mfrId) {
                    queryString += 'mfrId=' + mfrId;
                }
                if (searchText) {
                    if (queryString != '')
                        queryString += '&';
                    queryString += 'searchTerm=' + searchText;
                }
                if (page) {
                    if (queryString != '')
                        queryString += '&';
                    queryString += 'page=' + page;
                }
                axios
                    .get(searchBase + queryString, { crossdomain: true })
                    .then(response => {
                        if (response.data) {
                            this.searchContent.searchResult = response.data;
                            this.$root.$emit('change_panel', 'search');
                        }
                    })
                    .catch(() => {
                        this.$root.$emit('general_error', 'Search Failed');
                    });
            });

            this.$root.$on('change_panel', (panelName) => {
                this.$root.processExport = false;
                this.currentPanel = panelName;
            });

            this.$root.$on('export_part', (puid, exportFormats, exportOptions, dpns, consentOptions) => {
                var queueRequest = {
                    formats: exportFormats,
                    options: exportOptions,
                    distributorPNs: dpns,
                    consents: consentOptions
                };
                this.$root.processExport = true;
                axios
                    .post('api/v1/export/Queue?puid=' + puid, queueRequest, { crossdomain: true })
                    .then(response => {
                        if (response.data && response.data.is_found) { //part found and export queued
                            this.exportContent.exportToken = response.data.export_token;
                            if (response.data.is_processed) { //export complete
                                this.$root.$emit('export_download', response.data.export_token);
                            } else { //start checking
                                this.$root.$emit('export_check', response.data.export_token, 0);
                            }
                        } else { //export failed
                            this.$root.$emit('export_error', response.data.export_token, 0);
                        }
                    })
                    .catch(() => {
                        this.$root.$emit('export_error');
                    });
            });

            this.$root.$on('export_check', (exportToken, cycles) => {
                if (cycles <= 30 && this.$root.processExport) {
                    cycles += 1;
                    setTimeout(function (emitRoot, cycles) {
                        axios
                            .get('api/v1/export/Check?exportToken=' + exportToken, { crossdomain: true })
                            .then(response => {
                                if (response.data && response.data.is_found && emitRoot.processExport) { //export found
                                    if (response.data.is_processed) { //export complete
                                        emitRoot.$emit('export_download', exportToken);
                                    } else { //check again
                                        emitRoot.$emit('export_check', exportToken, cycles);
                                    }
                                }
                                //Release the export processing panel that needs to exist
                            })
                            .catch(() => {
                                emitRoot.$emit('export_error');
                            })
                            ;
                    }, 1000, this.$root, cycles);
                } else if (cycles > 30 && this.$root.processExport) {
                    this.$root.$emit('export_timeout');
                }
            });

            this.$root.$on('export_download', (exportToken) => {
                if (this.$root.processExport) {
                    this.$root.processExport = false;
                    //download the file
                    document.location.href = this.appUrl + '/api/v1/export/Export?exportToken=' + exportToken;
                }
            });

            this.$root.$on('login', () => {
                if (this.partContent.part_uuid !== undefined) {
                    axios
                        .get('api/v1/part/ConsentListing?part_unique_id=' + this.partContent.part_uuid, { crossdomain: true })
                        .then(response => {
                            this.exportContent.exportConsentViewModels = response.data;
                        })
                        .catch(() => {
                            this.$root.$emit('general_error', 'Consent Refresh Failed');
                        });
                }
            });
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    :root {
        --ul-red: #c51730;
        --ul-dark-gray: #5A5A5A;
        --ul-dark-gray-bg: #737373;
        --ul-light-gray: #d0d0d0;
        --ul-light-gray-bg: #d0d0d0;
        --ul-very-light-gray: #f6f6f6;
    }

    * {
        border-radius: 0 !important;
    }

    body {
        padding-top: 5px;
        padding-bottom: 0;
        max-width: 450px;
        margin: auto !important;
        min-height: 100%;
        height: 100%;
        font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
        background-color: #fff;
    }

    @media (max-width: 1299.9px) {

        body {
            font-size: 80%;
        }

        .ms-5-r {
            margin-left: 1.5rem;
            margin-right: 1.5rem;
        }
    }

    @media (min-width: 1300px ) {
        body {
            max-width: 1300px;
        }

        .ms-5-r {
            margin-left: 3rem;
            margin-right: 3rem;
        }
    }

    .ul-dark-gray-panel {
        border: 1px solid var(--ul-dark-gray);
    }

    .ul-wide-dark-gray-panel {
        border-left: 10px solid var(--ul-dark-gray) !important;
    }

    .ul-light-gray-panel {
        border: 1px solid var(--ul-light-gray);
    }

    .ul-wide-light-gray-panel {
        border-left: 10px solid var(--ul-light-gray) !important;
    }

    .ul-light-gray-panel-bottom {
        border-bottom: 1px solid var(--ul-light-gray);
    }

    .ul-very-light-background {
        background-color: var(--ul-very-light-gray);
    }

    .ul-light-background {
        background-color: var(--ul-light-gray-bg);
    }

    .ul-dark-background {
        background-color: var(--ul-dark-gray-bg);
    }

    .ul-red-panel {
        border: 1px solid var(--ul-red);
    }

    .required {
        color: var(--ul-red);
    }

    .preview-title {
        font-size: 16px;
        font-weight: bold;
        color: var(--ul-dark-gray);
        padding: 5px 0px 5px 0px;
    }

    .back-link {
        color: var(--ul-dark-gray);
    }

    .btn-dark {
        color: #fff !important;
        background-color: var(--ul-red);
        border: 1px solid var(--ul-red);
    }

    .btn-primary {
        color: #fff !important;
        background-color: var(--ul-dark-gray-bg);
        border-color: var(--ul-dark-gray-bg);
        color: var(--ul-dark-gray);
    }

    .btn-primary:hover {
        color: #fff !important;
        background-color: var(--ul-light-gray-bg);
        border-color: var(--ul-light-gray-bg);
        color: var(--ul-light-gray);
    }

    .btn-default {
        color: #333;
        background-color: #fff;
        border-color: #ccc;
    }

    .btn.disabled, .btn[disabled], fieldset[disabled] .btn {
        cursor: not-allowed;
    }

    .btn-dark.disabled, .btn-dark:disabled, .btn-dark[disabled] {
        color: white;
        background-color: var(--ul-red);
        border-color: var(--ul-red);
        opacity: .65;
    }

    .part-image {
        max-height: 50px;
        max-width: 75px;
    }
    
    .part-image-credit {
        font-size:.5em;
    }

    .svg-inline--fa {
        position: relative;
    }

    .ul-tooltip, .ul-html-tooltip {
        cursor: pointer;
        padding-left: 5px;
    }

    .tooltip {
        width: auto;
        max-width: 425px;
    }

    .tooltip-inner {
        width: 100%;
        max-width: none;
    }

    .tooltip > .tooltip-inner {
        background-color: black;
        border-top: 2px solid var(--ul-red);
        border-bottom: 2px solid var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before {
        border-top-color: var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before {
        border-right-color: var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before {
        border-bottom-color: var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before {
        border-left-color: var(--ul-red);
    }
</style>

